document.addEventListener('DOMContentLoaded', () => {
    const currencySelectors = document.querySelectorAll(
        '#currency-selector-header, #currency-selector-footer, #currency-selector-drawer, [id^="currency-selector"], .currency-selector select'
    );

    const selectsDefault = document.querySelectorAll('.currency-selector select')

    currencySelectors.forEach((selector) => {
        selector.addEventListener('change', this.handleCurrencyChange.bind(this));
    });

    selectsDefault.forEach(select => {
        const isUK = window.location.href.includes("uk-");
        const targetCurrency = isUK ? "GBP" : "USD";

        select.value = targetCurrency;

        [...select.options].forEach(option => {
            option.selected = option.value === targetCurrency;
        });
    });



})

function handleCurrencyChange() {
    if (window.location.href.includes("uk-")) {
        window.location.href = "https://jonathanadler.com/";
    } else {
        window.location.href = "https://uk.jonathanadler.com/";
    }
}


// --- iOS detect (top of action.js) -----------------------------------------
const IS_IOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

document.documentElement.classList.toggle('is-ios', IS_IOS);

// --- helpers ----------------------------------------------------------------
function initNativeXScroll(el) {
  // kill swiper if present
  if (el.swiper && typeof el.swiper.destroy === 'function') {
    el.swiper.destroy(true, true);
  }

  el.classList.add('native-x-scroll');
  el.style.touchAction = 'pan-x';
  el.style.webkitOverflowScrolling = 'touch';

  const wrap = el.querySelector('.swiper-wrapper') || el;
  wrap.style.display = 'flex';
  if (!wrap.style.gap) wrap.style.gap = '16px';

  wrap.querySelectorAll('.swiper-slide, .menu-drawer__enhanced-image-block').forEach((slide) => {
    slide.style.flex = '0 0 auto';
    slide.style.scrollSnapAlign = 'start';
  });
}

function initSwiperIfNeeded(el, options) {
  if (el.swiper) return; // already inited
  // eslint-disable-next-line no-undef
  el._swiper = new Swiper(el, options);
}

// --- main bootstrap you already have ---------------------------------------
function setupEnhancedImages(root = document) {
  root.querySelectorAll('.menu-drawer__enhanced-images').forEach((el) => {
    if (IS_IOS) {
      initNativeXScroll(el);
    } else {
      initSwiperIfNeeded(el, {
        // ...your existing Swiper options
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  });
}

// initial + dynamic sections
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setupEnhancedImages());
} else {
  setupEnhancedImages();
}
document.addEventListener('shopify:section:load', (e) => setupEnhancedImages(e.target));


document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < 968)
        new Swiper('.menu-drawer__enhanced-images.swiper', {
            slidesPerView: 1.1,
            spaceBetween: 16,
            autoHeight: true,
            observer: true,
            observeParents: true,
            preloadImages: true,
            lazy: false //
        });
})